import React, { useState } from "react";
import { Autocomplete, Box, Button, Checkbox, Divider, Fade, FormControlLabel, FormGroup, Stack, TextField, Typography } from "@mui/material";
import { Padding } from "../styles/StylesConstantes";
import { CssTextField } from "../styles/styles";
import { optionsSorteos } from "../constantes/constantes";

function AddUsuarioComponents({
    id, handleCancelar, handleGuardar, nameUser, handleNamerUser, apellidoUser,
    handleApellidoUser, emailUser, handleEmailUser, activo, setActivo,
    newPassword, setNewPassword, confirmPassword, setConfirmPassword,
    localSelected, handleLocalSelected, handleUpdatePassword
}) {
    const [viewNewPassword, setViewNewPassword] = useState(false);



    return (
        <Box>
            <Fade in={true} timeout={1000}>
                <Box sx={{}}>
                    <Box sx={{}}>
                        <div style={{}}>

                            {(id !== undefined && id !== null) && (
                                <div style={{}}>
                                    <Stack direction="row" spacing={2} style={{ marginTop: Padding.P3, marginBottom: Padding.P3 }}>
                                        <Button variant={viewNewPassword ? "outlined" : "contained"} onClick={() => setViewNewPassword(false)}>
                                            Datos
                                        </Button>

                                        <Button variant={viewNewPassword ? "contained" : "outlined"} onClick={() => setViewNewPassword(true)}>
                                            Nueva contraseña
                                        </Button>
                                    </Stack>

                                    <Divider style={{ marginTop: Padding.P1, marginBottom: Padding.P4 }} />
                                </div>
                            )}


                        </div>

                        {!viewNewPassword && (
                            <div style={{}}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <Typography variant={'subtitle1'}>
                                            Nombre
                                        </Typography>

                                        <CssTextField
                                            value={nameUser}
                                            onChange={(e) => handleNamerUser(e.target.value)}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            label="Nombre"
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                            style={{
                                                marginTop: Padding.P1,
                                                width: '95%'
                                            }}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Typography variant={'subtitle1'}>
                                            Apellido
                                        </Typography>

                                        <CssTextField
                                            value={apellidoUser}
                                            onChange={(e) => handleApellidoUser(e.target.value)}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            label="Apellido"
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                            style={{
                                                marginTop: Padding.P1,
                                                width: '95%'
                                            }}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Typography variant={'subtitle1'}>
                                            Email
                                        </Typography>

                                        <CssTextField
                                            value={emailUser}
                                            onChange={(e) => handleEmailUser(e.target.value)}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            label="Email"
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                            style={{
                                                marginTop: Padding.P1,
                                                width: '100%'
                                            }}
                                        />
                                    </div>
                                </div>


                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    marginTop: Padding.P3
                                }}>
                                    <div style={{ flex: 1 }}>

                                        <div style={{}}>
                                            <div>
                                                <Typography variant={'subtitle1'} style={{ marginBottom: Padding.P1 }}>
                                                    Local (Buscar por nombre de fantasía)
                                                </Typography>
                                            </div>

                                            <Autocomplete
                                                disablePortal
                                                options={optionsSorteos}
                                                sx={{ width: '95%' }}
                                                renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                                onInputChange={(event, newInputValue) => {
                                                    handleLocalSelected(newInputValue);
                                                }}
                                                value={localSelected}
                                            />

                                        </div>
                                    </div>


                                    <div style={{ flex: 1 }} />
                                    <div style={{ flex: 1 }} />

                                </div>

                                {(id !== undefined && id !== null) && (
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={activo} // Componente controlado
                                                    onChange={(e) => setActivo(e.target.checked)}
                                                />
                                            }
                                            label="Activo"
                                        />
                                    </FormGroup>
                                )}








                            </div>
                        )}

                        {viewNewPassword && (
                            <div style={{}}>
                                <div style={{}}>
                                    <div style={{ flex: 1 }}>
                                        <Typography variant={'h6'} style={{ marginBottom: Padding.P1 }}>
                                            Configuración de la contraseña nueva
                                        </Typography>


                                        <Typography variant={'subtitle1'}>
                                            Nueva contraseña
                                        </Typography>

                                        <CssTextField
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            label="Nueva contraseña"
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                            style={{
                                                marginTop: Padding.P1,
                                                width: 400
                                            }}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Typography variant={'subtitle1'}>
                                            Confirmación de la nueva contraseña
                                        </Typography>

                                        <CssTextField
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            label="Confirmación de la nueva contraseña"
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                            style={{
                                                marginTop: Padding.P1,
                                                width: 400
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {viewNewPassword ? (
                            <Stack direction="row" spacing={2} style={{ marginTop: Padding.P3 }}>
                                <Button variant="contained" onClick={handleUpdatePassword}>
                                   Actualizar
                                </Button>
                             
                            </Stack>
                        ) : (
                            <Stack direction="row" spacing={2} style={{ marginTop: Padding.P3 }}>
                                <Button variant="contained" onClick={handleGuardar}>
                                    {(id !== undefined && id !== null) ? 'Guardar' : 'Crear'}
                                </Button>

                                <Button variant="outlined" onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                            </Stack>
                        )}
                    </Box>
                </Box>
            </Fade>
        </Box>
    )
}

export default AddUsuarioComponents;